<div class="main content">

    <div class="component-title">
        <app-component-title componentName="לוח שנה למוסד" IconName="ScheduleIcon">
            <button class="issue-vacation-form-btn" (click)="openIssueVacationFormDialog()">
                הפקת טופס חופשות למוסד
            </button>
        </app-component-title>
    </div>

    <div *ngIf="calendarSvc.dataService.IsScheduleEditingBlocked" class="schedule-not-allowed">
        <div class="alert alert-danger notAllowedAlert">
            שים לב! מידע לצפיה בלבד. לא ניתן להוסיף / לעדכן מערכות שעות וחופשות בתקופה זו.
        </div>
    </div>

    <div class="" [class.schedule-view-only]="calendarSvc.dataService.IsScheduleEditingBlocked">


        <div class="content">
            <div class="row">
                <div class="col-xl-3 col-lg-4 col-md-4">
                    <app-institution-schedule></app-institution-schedule>
                </div>
                <div class="col-xl-9 col-lg-8 col-md-8">
                    <app-calendar #calendar (onSelectDay)="onSelectedDay($event)"></app-calendar>
                    <!-- <app-calendar (selectDayEvent)="getSelectedDays($event)"></app-calendar> -->
                </div>
            </div>
            <div class="row d-flex justify-content-end update-button-wrapper">
                <button (click)="openDialog(false)" class="button save-button" [disabled]="disableButton">קבע שעות סיום או
                    חופשה לימים שנבחרו</button>
            </div>
        </div>
        <div class="wrapping-border">

            <div class="content">
                <div class="row margin0">
                    <app-students-search #studentsSearch></app-students-search>
                    <div class="control-buttons">
                        <app-component-switcher (schedule)="selectScheduleType($event)">
                        </app-component-switcher>
                        <div class="d-flex flex-row">
                            <!-- <div class="desktopBtn">
                                <button class="add-schedule-btn" (click)="openAddClassScheduleDialog()">
                                  הוספת מ.שעות כיתתית
                                </button>
                              </div>                               -->
                        <div class="desktopBtn search-btn ">
                            <button [disabled]="setAuthorityStatusButtonDisabled()" (click)="manageAuthorityStatus()"
                                class="button-outline">
                                <div class="inner-button ">צפה בסטטוסים לרשויות</div>
                            </button>
                        </div>
                        <div class="desktopBtn search-btn ">
                            <button [disabled]="setCancelButtonDisabled()" (click)="changeStatus()"
                                class="button-outline">
                                <div class="inner-button ">שלח בקשה לביטול</div>
                            </button>
                        </div>
                    </div>
                </div>
                <app-class-schedule-list #classSchedulesList *ngIf="mainScheduleSelected"></app-class-schedule-list>
                <app-vacation-list #vacationsList (selectedVacations)="setSelectedVacations($event)"
                    *ngIf="!mainScheduleSelected">
                </app-vacation-list>
            </div>
        </div>
        <div class="content container-fluid">
            <div class="row">
                <div class="col-xl-8 col-lg-7 col-md-8">
                    <app-student-list #studentsList (selectAllEmit)="selectAllStudents($event)"></app-student-list>
                </div>
                <div class="col-xl-4 col-lg-5 col-md-4">
                    <app-student-schedule (callback)="callbackLoadClassSchedules()"
                        [enableUpdateAll]="selectAllStudentsValue" *ngIf="mainScheduleSelected">
                    </app-student-schedule>
                    <app-special-vacation (callback)="callbackLoadVacation()" [enableUpdateAll]="selectAllStudentsValue"
                        [selectedVacationsList]="selectedVacations" *ngIf="!mainScheduleSelected">
                    </app-special-vacation>
                </div>
            </div>

                <!-- <div *ngIf="!mainScheduleSelected" class="row d-flex justify-content-end">
                    <button class="button save-button col-3">עדכן תלמידים שנבחרו</button>
                </div> -->
        </div>
    </div>
</div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.6)" size="large" color="#fff" type="ball-scale-multiple" [fullScreen]="true">
    <p style="color: white"> אנא המתן... </p>
</ngx-spinner>